/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SupplierInvoiceService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code, params) {
    const requestScreenData = {
      url: "api/SupplierInvoice",
      top: "1",
      filter: `Code eq ${code}`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  async getBySupplierCode(supplierCode, params) {
    const requestScreenData = {
      url: "api/SupplierInvoice",
      // top: "1",
      filter: `SupplierCode eq '${supplierCode}'`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async saveSupplierInvoice(payload, invoiceId) {
    const url = `api/Save_SupplierInvoice`;

    if (invoiceId) {
      return await ApiService.put(url, invoiceId, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },

  async saveSupplierInvoiceDueDate(payload, invoiceId) {
    const url = `api/Save_SupplierInvoiceDueDate`;

    if (invoiceId) {
      return await ApiService.put(url, invoiceId, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },
  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      select: ["StartDate", "EndDate"],
      filter: `PeriodType eq 'AP'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      select: ["StartDate", "EndDate"],
      filter: `PeriodType eq 'AP'`,
      orderby: "EndDate desc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCustomData(params) {
    const requestScreenData = {
      url: "api/" + params.url,
      filter: params.filter,
      select: params.select,
    };

    if (params.orderby) requestScreenData.orderby = params.orderby;

    return await ApiService.oDataGet(requestScreenData);
  },
  async getPurchaseOrdersBySupplierCode(code) {
    const requestScreenData = {
      // url: "api/GoodsInList",
      url: "api/GoodsInDetail",
      apply: `filter(SupplierCode eq '${code}' and Invoiced eq 'N' and ReceivedQty ne 0 and Status ne 'C')/groupby((PurchaseOrderCode,PurchaseOrderDate))`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  async getPurchaseOrders(params) {
    const requestScreenData = {
      url: "api/GoodsInDetail",
      apply:
        "filter(Invoiced eq 'N' and ReceivedQty ne 0 and Status ne 'C')/groupby((PurchaseOrderCode))",
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveSupplierInvoiceDueDateBulkUpdate(payload) {
    const url = `api/Save_SupplierInvoiceDueDate/BulkUpdate`;

    return await ApiService.post(url, payload);

  },

  async getAttachedFiles(code) {
    const requestScreenData = {
      url: "api/TransactionMediaMeta",
      filter: `TransactionRecordID eq ${code} and TransactionType eq 'SupplierInvoice'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async updateTransactionMediaMeta(payload) {
    const url = `api/TransactionMediaMeta`;
    return await ApiService.post(url, payload);
  }
};

export { SupplierInvoiceService };
